<template>
    <div class="phone:fixed phone:bg-white phone:bottom-0 phone:left-0 phone:w-full phone:z-10 phone:px-4 py-2 phone:w-2/3 phone:flex phone:flex-col phone:justify-start ">
        <h3
            class="text-gold-500 tablet:text-white uppercase tablet:mb-3 phone:text-xs phone:mb-2"
            v-text="socialShareTitle" />
        <div class="flex flex-row">
            <social-share-button
                v-for="(network, index) in socialNetworks"
                :key="index"
                :social-icon="network.icon"
                :url="network.url"
                :post-slug="postSlug"
                :category-slug="categorySlug"
                target="_blank"
            />
        </div>
    </div>
</template>

<script>
import SocialShareButton from '@whisper/components/buttons/SocialShareButton';

export default {
  name: 'SocialSharePosts',
  components: { SocialShareButton },
  props: {
    socialShareTitle: {
      type: String,
      required: true,
    },
    socialNetworks: {
      type: Array,
      required: true,
    },
    postSlug: {
      required: false,
    },
    categorySlug: {
      required: false,
    },
  },
};
</script>

<style scoped>

</style>
